module.exports = __webpack_public_path__ + "img/mv02.9b441160.jpg";